const platformSupportsStreaming = () => !process.env.LAMBDA_TASK_ROOT && !process.env.VERCEL;

export { platformSupportsStreaming };
//# sourceMappingURL=platformSupportsStreaming.js.map
